import React from "react";
import Loader from 'react-loader-spinner'
import FilterModal from "../../modals/FilterModal";
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
// import FilterViewer from "../FilterViewer";
// import FilterModal from '../modals/FilterModal';
// import Modal from "../Modal";


class AdvancedSelectInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        lastNewId: 0,
        search: ''

    }

    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            document.addEventListener('mousedown', this.closeBox);
            window.addEventListener('scroll', this.getPosition, true);
            this.getPosition()

        } else {
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

        }
        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }



    changeItem = (prop, selected, dontChangeValue) => {

        // console.log(prop)
        // var choosen = this.state.choosen
        this.setState({ title: '', search: '', choosen: prop }, () => {
            this.changeValue()
            if (this.state.tempData.length > 0)
                this.setState({ options: this.state.tempData })

            // if (this.refs.input)
            //     this.refs.input.focus()
        })


        // if (selected) {
        //     for (let i = 0; i < choosen.length; i++) {

        //         if (choosen[i].value == prop.value) {
        //             choosen.splice(i, 1)
        //         }
        //     }
        // } else {
        //     choosen.push(prop)
        // }

        // this.setState({ choosen }, () => {
        //     if (!dontChangeValue) 
        // })

        setTimeout(() => {
            this.toggleOpen(false)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );




        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        if (prevProps.data != this.props.data && this.mounted) {
            // this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {

                let options = []
                let choosen = []

                if (this.props.header.information.items && this.props.header.information.items.length > 0) {
                    options = this.props.header.information.items
                }

                if (this.props.title && Array.isArray(this.props.title)) {
                    this.props.title.forEach(element => {
                        choosen.push({ title: element, value: element })
                    });
                }
                // console.log(this.props.title)
                this.setState({ options, choosen })
            } else if (this.props.header.information.type == "api") {
                // console.log(this.props.title)
                this.fetch()
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : this.props.header.information.filter
        // console.log(filter)
        console.log(filter)

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }
        // console.log(this.props.variables)
        console.log(address)
        console.log(filter)

        // keep a separate map of the full fetched records by value
        this.fullFetchedData = {}

        HttpService.request(address, filter, (fetchResult, fetchError) => {
            if (fetchError) { return }

            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            let newData = []
            let newParents = []

            fetchResult.info.sort((a, b) => { return a.values?.parent - b.values?.parent })

            // console.log(fetchResult)
            fetchResult.info.forEach(element => {

                let newTitle = this.spliter(element, this.props.header.information.fields.title)
                let newValue = this.spliter(element, this.props.header.information.fields.value)
                let newImage
                let newDescription
                let newDescription2
                if (this.props.header.information.fields.image) {
                    newImage = this.spliter(element, this.props.header.information.fields.image)
                }
                if (this.props.header.information.fields.description) {
                    newDescription = this.spliter(element, this.props.header.information.fields.description)
                }
                if (this.props.header.information.fields.description2) {
                    newDescription2 = this.spliter(element, this.props.header.information.fields.description2)
                }
                let parent = this.spliter(element, this.props.header.information.fields.parent)
                newTitle = newTitle.replace('ي', 'ی')

                // keep original option shape
                newData.push({ value: newValue, title: newTitle, image: newImage, description: newDescription, description2: newDescription2, parent: (typeof parent == 'object' ? parent._id : parent) })

                // separately store the full fetched record for this value
                if (newValue != null) {
                    this.fullFetchedData[newValue] = element
                }

            });



            newParents.sort((a, b) => { return a.values?.name - b.values?.name })


            // console.log(this.props.data)

            if (this.props.data) {

                let data = this.props.data
                if (Array.isArray(data)) {
                    data = data[0]
                }

                newData.forEach(oneNewData => {
                
                    if (oneNewData.value == data._id ?? data) {
                        this.setState({ choosen: oneNewData })
                        // choosen.push({ title: oneNewData.title, value: oneTitleId })
                    }
                });
            }

            // if (Array.isArray(this.props.data)) {
            //     let choosen = []
            //     this.props.data.forEach(oneTitle => {
            //         let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
            //         newData.forEach(oneNewData => {

            //             if (oneNewData.value == oneTitleId) {
            //                 choosen.push({ title: oneNewData.title, value: oneTitleId })
            //             }
            //         });

            //     })
            //     this.setState({ choosen })
            //     // console.log(choosen)


            // }

            this.setState({
                options: newData,
                parents: newParents,
                isLoading: false
            })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }


    spliter(source, string) {
        if (string) {
            var stringArray = string.split('.')
            var finalString = source
            stringArray.forEach(element => {
                finalString = finalString[element]
            });
        }
        return finalString
    }




    search = async (value) => {
        this.setState({ title: value })
        this.setState({ search: value })

        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData }, async () => {
                await this.setState({ tempData: [] })
            })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options }, () => {
                })
            }
            var values = []
            this.state.tempData.forEach(element => {
                console.log(element)
                // value.replace('','ي')
                console.log('qqqqqqqqqqqq', value)
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })

            this.setState({ options: values })
        }
    }


    removeItem(index) {
        this.setState({ choosen: '' }, () => {
            this.changeValue()
        })
    }



    changeValue() {
        // keep the original way of deriving finalValue from choosen
        let finalValue = (typeof (this.state.choosen == 'object' && !Array.isArray(this.state.choosen)) ? this.state.choosen.value : this.state.choosen)

        // look up the full fetched record by the chosen value, without modifying choosen itself
        let fullData
        if (this.fullFetchedData && this.state.choosen && this.state.choosen.value != null) {
            fullData = this.fullFetchedData[this.state.choosen.value]
        }

        const extra = { ...(this.props.extra || {}), fullData }

        this.props.changeValue(this.props.header.key, finalValue, extra)
    }

    openFilter = () => {
        this.filterModal.modal.showModal()
    }



    render() {
        return (
            <div className='mt-0 w-100 h-100 flexc ' style={{ position: 'relative' }}  >



                <div ref={ref => this.setWrapperRef(ref)} className="w-100" >

                    <div className="flexcb w-100 h-100">
                        <div onClick={() => !this.props.header.information?.disabled ? this.toggleOpen(true) : ''} style={{ flex: 1, cursor: 'pointer' }}>
                            {(!this.props.data || this.props.data == '' || !this.state.choosen?.title) && (
                                <div className="h-100 flexc" style={{ flex: 1 }}>
                                    <label className={' mr-1 ml-1 placeholder '}>{this.props.header.information.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : 'Select'}</label>
                                </div>
                            )}

                            {(this.props.data && this.props.data != '' && this.state.choosen?.title) && (
                                <div className="text-start" style={{ cursor: 'pointer', flex: 1 }}>
                                    <p style={{ margin: 0 }}>{this.state.choosen.title}</p>
                                    {!this.props.header.information.dontShowExtraValue &&(
                                        <>
                                    {(this.state.choosen.description || this.state.choosen.description2) && (
                                        <p style={{ margin: 0, marginTop: 2, fontSize: 12, color: '#789' }}>
                                            {this.state.choosen.description}
                                            {this.state.choosen.description && this.state.choosen.description2 ? ' - ' : ''}
                                            {this.state.choosen.description2}
                                        </p>
                                    )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        {this.props.header.information?.search && (
                            <button onClick={() => this.openFilter()} className="flexcc">
                                <img src="https://www.flaticon.com/svg/static/icons/svg/3126/3126539.svg" height="20px" />
                            </button>
                        )}
                    </div>


                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 3, right: 5 }}>
                            <Loader
                                type="Oval"
                                color="#FF6C00"
                                height="20"
                                width="20"
                            />
                        </div>
                    )}



                    {this.state.isOpen && (
                        <div className="text-start" style={{ top: this.state.top, left: this.state.left, display: 'flex', position: 'fixed', width: '100%', zIndex: 5, maxWidth: 300 }}>
                            <div className={''} style={{ paddingBottom: 20, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffffee', borderRadius: 4, maxHeight: 300, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>
                                {this.props.header.information.isSearchable && (
                                    <input className="" value={this.state.search} onChange={event => this.search(event.target.value)} placeholder={translate('Search')} style={{ zIndex: 1, fontSize: 14, alignSelf: 'stratch', padding: '8px 10px', backgroundColor: '#fff', borderRadius: 4, border: '#e0e2e6 solid 1px', marginTop: 0, position: 'sticky', top: 0 }} />
                                )}

                                {this.state.options.length != 0 && (
                                    <div className="mt-2" onClick={() => this.changeItem({ value: '' })} style={{ cursor: 'pointer', backgroundColor: 'transparent', opacity: 0.5, padding: '5px 20px' }}>
                                        <p style={{ margin: 0, color: '#456', fontSize: 13 }}>{checkTranslation(this.props.header?.information?.defaultPlaceholder ?? translate('None'))}</p>
                                    </div>
                                )}

                                {this.state.options?.map((cprop, cindex) => {
                                    let cselected = false
                                    return (
                                        <div className="">
                                            <div className="flexc " key={cindex} onClick={() => this.changeItem(cprop, cselected)} style={{ cursor: 'pointer', backgroundColor: cselected ? '#f7f7f7' : '#transparent', padding: '5px 20px' }}>
                                                {this.props.header.information?.fields?.image && (
                                                    <div className="flexcc">
                                                        <img className="mrd-3" src={imageAddress(cprop.image, 'resource', 'small')} width="30px" height="30px" alt="" style={{ borderRadius: 40, objectFit: 'cover' }} />
                                                    </div>
                                                )}
                                                <div className="d-flex flex-column justify-content-center">
                                                    <p className="" style={{ margin: 0, color: '#777', fontSize: 12 }}>{cprop.title}</p>
                                                    {(cprop.description || cprop.description2) && (
                                                        <p style={{ margin: 0, marginTop: 2, color: '#789', fontSize: 11, lineHeight: 1.2 }}>
                                                            {cprop.description}
                                                            {cprop.description && cprop.description2 ? ' - ' : ''}
                                                            {cprop.description2}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}


                                {this.state.options.length == 0 && (
                                    <div className="px-2 pt-3">
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate('found-nothing')}</p>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}

                </div>
                <FilterModal ref={el => this.filterModal = el} headers={this.props.header.information?.search?.headers} initData={this.state.filter} />
            </div>
        );
    }
}


export default AdvancedSelectInput;
